// src/lib/auth-refresh-gate.ts

let refreshPromise: Promise<unknown> | null = null;

export function setRefreshPromise(promise: Promise<unknown>): void {
  refreshPromise = promise;
}

export function getRefreshPromise(): Promise<unknown> | null {
  return refreshPromise;
}

export function clearRefreshPromise(): void {
  refreshPromise = null;
}
